
<div class="w-full max-h-[80vh] flex flex-col overflow-hidden">
    <div class="flex items-center justify-between mb-4">
        <p class="text-4xl font-semibold">Detalle Registro</p>
        <button class="px-4 py-2 bg-gray-200 rounded-lg" (click)="_dialogRef.close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="w-full flex-1 overflow-y-auto pr-2">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="Detalles Generales">
                <registros-form-componenent></registros-form-componenent>
            </mat-tab>
            <mat-tab label="Requerimientos Academicos">
                <app-requerimietos-academicos [carreaModel]="carreaModel"></app-requerimietos-academicos>
            </mat-tab>
            <mat-tab label="Bitácora">
                <ng-template matTabContent>
                    <app-bitacora [entidadUuid]="carreaModel.carreraUuid"></app-bitacora>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>


</div>
